import {
    FETCH_STORYBOARD_QUESTIONS_FAILED,
    FETCH_STORYBOARD_QUESTIONS_START,
    FETCH_STORYBOARD_QUESTIONS_SUCCESS
} from '../../constants';
import { BATCH_QUESTIONS_URL } from '../../../../config/constants';
import { ApiBase } from '../../../utils/apiBase';
import { withType } from '../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../utils/apiUtils';

export const fetchStoryboardQuestions = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(FETCH_STORYBOARD_QUESTIONS_START, {}));
        apiBaseInstance.instance
            .post(BATCH_QUESTIONS_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(FETCH_STORYBOARD_QUESTIONS_SUCCESS, {
                    data: response.data,
                    message: response.message,
                }));
                setTimeout(() => {
                    cb && cb(response.data);
                }, 0)
            })
            .catch(err => {
                dispatch(withType(FETCH_STORYBOARD_QUESTIONS_FAILED, {
                    error: err
                }));
            });
    };
};

